// extracted by mini-css-extract-plugin
export default {"periodTabs":"styles_periodTabs__GQDtA","periodTabs__mobile":"styles_periodTabs__mobile__OEMs1","periodTabs__disabled":"styles_periodTabs__disabled__ovuiJ"};